import { GroupedFormData, ReportFormRuleTemplate } from '@navstation-portal/reporting/data-model/ui';
import { IReport, ReportStatus } from '@navstation-portal/reporting/data-model/vessel-report';
import { ReportType } from '@navstation-portal/reporting/data-model/vessel-report';
import { ReducedVesselReport } from '@navstation-portal/reporting/data-model/vessel-reports';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const reportEvents = eventGroup({
  source: 'ReportStore',
  events: {
    getCarryoverData: type<{ vesselId: string; reportId?: string }>(),
    createNewReport: type<{ reportType: ReportType }>(),
    openReport: type<{ vesselId: string; reportId: string }>(),
    gotCarryoverData: type<IReport>(),
    getFormFieldRules: type<string>(),
    gotFormFieldRules: type<Record<string, GroupedFormData>>(),
    gotFormRuleTemplate: type<ReportFormRuleTemplate>(),
    /**
     * Asks the store to put every value the template carries into the new
     * report. `createNewReport` dispatches it once, after the tab stores build
     * their form state, and nothing else dispatches it: opening a report that
     * already exists must change no field.
     *
     * The store answers rather than the effect, because the walk reads
     * `ruleContext` and the effect feature sits before it in the chain. This
     * event is what carries the trigger across that boundary.
     */
    carryOverOnCreate: type<void>(),
    createReportSuccess: type<void>(),
    createReportFailed: type<{ error: string }>(),
    openReportSuccess: type<{ status: ReportStatus }>(),
    openReportFailed: type<{ notFound: boolean }>(),
    saveReport: type<{
      vesselId: string;
      reportId?: string;
      reportType: ReportType;
      notes: string;
      status: ReportStatus;
      closeAfterSave?: boolean;
    }>(),
    saveReportSuccess: type<{ reportId: string; report: ReducedVesselReport; closeAfterSave?: boolean }>(),
    saveReportFailed: type<{ error: string }>(),
    submitReport: type<{
      vesselId: string;
      reportId?: string;
      reportType: ReportType;
      notes: string;
      submitType: string;
    }>(),
    submitReportSuccess: type<{ report: ReducedVesselReport }>(),
    submitReportFailed: type<{ error: string }>(),
    deleteReport: type<{ vesselId: string; reportId?: string }>(),
    deleteReportSuccess: type<{ reportId?: string }>(),
    deleteReportFailed: type<{ error: string }>(),
    setReportType: type<ReportType>(),
    setLocalReportId: type<string>(),
    setNotes: type<string>(),
    reset: type<void>(),
  },
});
